import { cdn } from "constants/common";
import React from "react";
import { Table } from "reactstrap";
import { usePermissions } from "layouts/Admin";
import { useSelector } from "react-redux";
import { userSelector } from "slices/userSlice";

const TransLogsTable = ({ item }) => {
  // const formattedDate = moment(timeZone).format('MMMM DD YYYY, hh:mm A');
  const renderTableHeader = React.useCallback(() => {
    return (
      <tr>
        <th className="col-3">Doc Name</th>
        <th className="col-2">Total Words Count</th>
        {/* <th className="col-2">Estimated Words Count</th> */}
        <th className="col-2">Total Estimated Amount</th>
      </tr>
    );
  }, []);

  const renderTableContent = React.useCallback((item) => {
    return <LogItem item={item} key={item?.id} />;
  }, []);

  return (
    <div className="table_responsive">
      <table className="table">
        <thead className="text-primary">{renderTableHeader()}</thead>
        <tbody>
          {item?.translation_files &&
            item?.translation_files?.map((item) => renderTableContent(item))}
        </tbody>
      </table>
    </div>
  );
};


const LogItem = ({ item }) => {
  const { checkPermission } = usePermissions();
  const { user } = useSelector(userSelector);
  const role = user?.role ?? user?.user?.role;
  console.log("log item", item);
  return (
    <tr>
      <td className="col-3">
        {role === "subuser"
          ? checkPermission("Download Documents")
            ? (
                <a href={cdn + item?.original_file} target="_blank" rel="noreferrer noopener">
                  {item?.original_file_name || "N/A"}
                </a>
              )
            : (item?.original_file_name || "N/A")
          : (
              <a href={cdn + item?.original_file} target="_blank" rel="noreferrer noopener">
                {item?.original_file_name || "N/A"}
              </a>
            )}
      </td>
      <td className="col-2">{item?.word_count ?? "N/A"}</td>
      {/* <td className="col-2">{item?.est_words_count ?? 0}</td> */}
      <td className="col-2">$ {item?.amount ?? 0}</td>
    </tr>
  );
};
export default TransLogsTable;
